export default __webpack_public_path__ + "static/media/28mm white cap.95b09e35.jpeg";